<template>
  <div class="w-100">
    <app-info-bar></app-info-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import AppInfoBar from 'components/app-info-bar'

export default {
  name: 'PublicLayout',
  components: { AppInfoBar }
}
</script>



// WEBPACK FOOTER //
// src/layouts/login/index.vue